<!--
  ~ Copyright 2026 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="offset-md-3" [formGroup]="globalPaymentsFormGroup">
  <fieldset>
    <div class="form-group fieldIsRequired">
      <label class="col-md-8 control-label" for="globalPaymentsMerchantName"
        >Name</label
      >
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          formControlName="globalPaymentsMerchantName"
          id="globalPaymentsMerchantName"
          maxlength="100"
          [ngClass]="{
            'is-invalid':
              globalPaymentsFormGroup.controls.globalPaymentsMerchantName
                .invalid &&
              (globalPaymentsFormGroup.controls.globalPaymentsMerchantName
                .dirty ||
                globalPaymentsFormGroup.controls.globalPaymentsMerchantName
                  .touched)
          }"
        />
        <div
          class="formValidationMessage mt-1"
          *ngIf="
            globalPaymentsFormGroup.controls.globalPaymentsMerchantName
              .invalid &&
            (globalPaymentsFormGroup.controls.globalPaymentsMerchantName
              .dirty ||
              globalPaymentsFormGroup.controls.globalPaymentsMerchantName
                .touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="
              globalPaymentsFormGroup.controls.globalPaymentsMerchantName.errors
                ?.required
            "
          >
            Field is required.
          </div>
          <div
            class="text-danger"
            *ngIf="
              globalPaymentsFormGroup.controls.globalPaymentsMerchantName.errors
                ?.maxlength
            "
          >
            Name cannot exceed 100 characters.
          </div>
        </div>
      </div>
    </div>
    <div class="form-group fieldIsRequired">
      <label class="col-md-8 control-label" for="globalPaymentsSiteId">
        Global Payments Site ID
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          formControlName="globalPaymentsSiteId"
          id="globalPaymentsSiteId"
          maxlength="50"
          [ngClass]="{
            'is-invalid':
              globalPaymentsFormGroup.controls.globalPaymentsSiteId.invalid &&
              (globalPaymentsFormGroup.controls.globalPaymentsSiteId.dirty ||
                globalPaymentsFormGroup.controls.globalPaymentsSiteId.touched)
          }"
        />
        <div
          class="formValidationMessage mt-1"
          *ngIf="
            globalPaymentsFormGroup.controls.globalPaymentsSiteId.invalid &&
            (globalPaymentsFormGroup.controls.globalPaymentsSiteId.dirty ||
              globalPaymentsFormGroup.controls.globalPaymentsSiteId.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="
              globalPaymentsFormGroup.controls.globalPaymentsSiteId.errors
                ?.required
            "
          >
            Field is required.
          </div>
          <div
            class="text-danger"
            *ngIf="
              globalPaymentsFormGroup.controls.globalPaymentsSiteId.errors
                ?.maxlength
            "
          >
            Global Payments Site ID cannot exceed 50 characters.
          </div>
        </div>
      </div>
    </div>
    <div class="form-group fieldIsRequired">
      <label class="col-md-8 control-label" for="globalPaymentsKey">Key</label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          formControlName="globalPaymentsKey"
          id="globalPaymentsKey"
          maxlength="50"
          [ngClass]="{
            'is-invalid':
              globalPaymentsFormGroup.controls.globalPaymentsKey.invalid &&
              (globalPaymentsFormGroup.controls.globalPaymentsKey.dirty ||
                globalPaymentsFormGroup.controls.globalPaymentsKey.touched)
          }"
        />
        <div
          class="formValidationMessage mt-1"
          *ngIf="
            globalPaymentsFormGroup.controls.globalPaymentsKey.invalid &&
            (globalPaymentsFormGroup.controls.globalPaymentsKey.dirty ||
              globalPaymentsFormGroup.controls.globalPaymentsKey.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="
              globalPaymentsFormGroup.controls.globalPaymentsKey.errors
                ?.required
            "
          >
            Field is required.
          </div>
          <div
            class="text-danger"
            *ngIf="
              globalPaymentsFormGroup.controls.globalPaymentsKey.errors
                ?.maxlength
            "
          >
            Key cannot exceed 50 characters.
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>
